import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DmcPackageService } from 'src/app/business-service/dmc-package/dmc-package.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { LovDataService } from 'src/app/modules/shared/services/lov-data/lov-data.service';
import { ModalsService } from 'src/app/modules/shared/services/modals/modals.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-dmc-package-cancellation-policy',
  templateUrl: './dmc-package-cancellation-policy.component.html',
  styleUrls: ['./dmc-package-cancellation-policy.component.scss'],
})
export class DmcPackageCancellationPolicyComponent implements OnInit {

  @Input() packageId: any;

  @Input() editPackageId: any;

  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter<any>();

  @Input() storedFormData: any;
  @Input() hideFooter: boolean = false;

  @Output() makeFormDirty: EventEmitter<boolean> = new EventEmitter<boolean>();

  itemsForm!: FormGroup;

  constructor(
    private _lovDataService: LovDataService,
    private _globalService: GlobalService,
    private _modalPopupService: ModalsService,
    private _dmcPackageService: DmcPackageService,
    private _responseNotificationService: ResponseNotificationService,
    private _fb: FormBuilder
  ) { }

  ngOnInit() {
    this.itemsForm = this._fb.group({
      cancellationPolicys: [[]],
      note: ['']
    });
    this.itemsForm.valueChanges.subscribe(() => {
      this.makeFormDirty.emit(true);
    })
    if (this.storedFormData) {
      this.itemsForm.patchValue(this.storedFormData);
      this.makeFormDirty.emit(false);
    } else {
      this._lovDataService.getLovItineraryData('CancellationPolicy').subscribe(data => {
        data.map((item: { addedByUser: boolean; }) => {
          item.addedByUser = false;
        });
        this.itemsForm.patchValue({
          cancellationPolicys: data
        });
      });
    }
  }

  async onSubmit(): Promise<boolean> {
    let formData = await this.serializeFormData(this.itemsForm.value);

    return new Promise((resolve) => {
      this._dmcPackageService.addCancellationPolicy(formData).subscribe({
        next: (data: any) => {
          this.storeFormData.emit(data);
        },
        error: (error) => {
          console.error('Error saving package: ', error);
          this._responseNotificationService.showMessage("Error saving Cancellation Policy", true);
          resolve(false);
        },
        complete: () => {
          this.resetFormState();
          // this._responseNotificationService.showMessage("Cancellation Policy added successfully");
          resolve(true);
        }
      });
    });
  }

  private resetFormState(): void {
    this.makeFormDirty.emit(false);
  }


  private async serializeFormData(formData: any) {
    const serializedData = {
      ...formData,
      packageId: this.packageId,
      organizationId: this.storedFormData?.organizationId,
      id: this.storedFormData ? this.storedFormData.id : null,
      ownership: this.storedFormData ? this.storedFormData.ownership : null,
      createdBy: this.storedFormData ? this.storedFormData.createdBy : null,
      ...(this.storedFormData && { createDate: this.storedFormData.createDate })
    }

    return serializedData;
  }


  async resetForm() {
    if (await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")) {
      this.ngOnInit();
    }
  }

  goPrevious() {
    this.viewChange.emit(true);
  }

  goNext() {
    this.viewChange.emit(false);
  }

  async saveAndNext() {
    if (await this.onSubmit()) {
      this.goNext()
    }
  }

  formDataModified(): boolean {
    return (this.itemsForm.dirty || this.itemsForm.invalid) && this.itemsForm.touched;
  }

  setDefaultLov(item:any, type:string, formControlName:string){
    const payload:any = {
      name: item.name
    }
    this._lovDataService.addDefaultLovData(type, payload).subscribe({
      next: (res) => {
        this._responseNotificationService.showMessage("Item added to default list");
        // make addedByUser false for item
        const currentItems = this.itemsForm.get(formControlName)?.value || [];
        const updatedItems = currentItems.map((i: any) => {
          if(i.key === item.key){
            i.addedByUser = false;
          }
          return i;
        });
        this.itemsForm.patchValue({ [formControlName]: updatedItems });
        this.itemsForm.markAsDirty();
        this.itemsForm.markAsTouched();
      },
      error: (err) => {
        console.error("Error adding default", err);
        this._responseNotificationService.showMessage("Error adding default", true);
      }
    });
  }

  async removeDefaultLov(item:any, type:string, formControlName:string){
    let flag = await this._globalService.confirmActionPopup("Removing the item from default list will affect all users in the organization. Please confirm to proceed.", "Confirm to proceed", "Confirm");
    if(!flag){
      return;
    }
    this._lovDataService.removeDefaultLovData(type, item.key).subscribe({
      next: (res) => {
        this._responseNotificationService.showMessage("Item removed from default list");
        const currentItems = this.itemsForm.get(formControlName)?.value || [];
        const updatedItems = currentItems.filter((i: any) => i.key !== item.key);
        this.itemsForm.patchValue({ [formControlName]: updatedItems });
        this.itemsForm.markAsDirty();
        this.itemsForm.markAsTouched();
      },
      error: (err) => {
        console.error("Error removing default", err);
        this._responseNotificationService.showMessage("Error removing default", true);
      }
    });
  }

}
